/**
 * UI Store
 *
 * Manages UI-related state: modals, toasts, sidebar, theme, loading states
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
const initialState = {
    isModalOpen: false,
    modalType: null,
    modalData: null,
    toasts: [],
    isSidebarCollapsed: false,
    globalLoading: false,
    loadingMessage: null,
    theme: 'system',
};
export const useUIStore = create()(persist((set, get) => ({
    ...initialState,
    // Modal actions
    openModal: (type, data) => set({
        isModalOpen: true,
        modalType: type,
        modalData: data || null,
    }),
    closeModal: () => set({
        isModalOpen: false,
        modalType: null,
        modalData: null,
    }),
    // Toast actions
    showToast: (toast) => {
        const id = `toast-${Date.now()}-${Math.random()}`;
        const newToast = { ...toast, id };
        set((state) => ({
            toasts: [...state.toasts, newToast],
        }));
        // Auto-remove toast after duration
        const duration = toast.duration || 5000;
        if (duration > 0) {
            setTimeout(() => {
                get().removeToast(id);
            }, duration);
        }
    },
    removeToast: (id) => set((state) => ({
        toasts: state.toasts.filter((toast) => toast.id !== id),
    })),
    clearToasts: () => set({ toasts: [] }),
    // Sidebar actions
    toggleSidebar: () => set((state) => ({
        isSidebarCollapsed: !state.isSidebarCollapsed,
    })),
    setSidebarCollapsed: (collapsed) => set({ isSidebarCollapsed: collapsed }),
    // Loading actions
    setGlobalLoading: (loading, message) => set({
        globalLoading: loading,
        loadingMessage: message || null,
    }),
    // Theme actions
    setTheme: (theme) => set({ theme }),
    // Reset
    reset: () => set(initialState),
}), {
    name: 'medsuite-ui-store',
    partialize: (state) => ({
        // Only persist these fields
        isSidebarCollapsed: state.isSidebarCollapsed,
        theme: state.theme,
    }),
}));
//# sourceMappingURL=ui.store.js.map